import React from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Reply, Trash2, Pencil } from 'lucide-react';
import { API_URL } from './chatShared';
import { EmojiText } from './EmojiText';

export const REACTIONS = ['👍', '❤️', '😂', '😮', '😢', '🙏', '✅'];

const react = (msgId, emoji, onChanged) => axios.post(`${API_URL}/chat/messages/${msgId}/react`, { emoji }).then(onChanged)
  .catch((e) => toast.error(e?.response?.data?.detail || 'Erro na reação'));

export const ReactionBar = ({ m, mine, below, onClose, onChanged, onReply, onDelete, onEdit }) => (
  <div className={`absolute ${below ? 'top-full mt-1' : '-top-11'} ${mine ? 'right-0' : 'left-0'} z-[61] w-max max-w-[calc(100vw-24px)] overflow-x-auto flex gap-0.5 bg-white rounded-full shadow-lg border border-slate-200 px-1.5 py-1 animate-in fade-in zoom-in-95 duration-150`} data-testid={`chat-react-bar-${m.id}`}>
    {REACTIONS.map((e) => (
      <button key={e} type="button" onClick={() => { react(m.id, e, onChanged); onClose(); }} className="shrink-0 p-0.5 sm:p-1 rounded-full hover:bg-slate-100 hover:scale-125 transition-transform" data-testid={`chat-react-${m.id}-${REACTIONS.indexOf(e)}`}>
        <EmojiText text={e} size="1.35rem" />
      </button>
    ))}
    {(onReply || onDelete) && <span className="w-px bg-slate-200 mx-0.5 sm:hidden" />}
    {onReply && <button type="button" onClick={() => { onReply(); onClose(); }} className="sm:hidden shrink-0 p-1 rounded-full text-slate-500 hover:bg-slate-100" data-testid={`chat-bar-reply-${m.id}`}><Reply className="w-4 h-4" /></button>}
    {onEdit && <button type="button" onClick={() => { onClose(); onEdit(); }} className="sm:hidden shrink-0 p-1 rounded-full text-sky-600 hover:bg-sky-50" data-testid={`chat-bar-edit-${m.id}`}><Pencil className="w-4 h-4" /></button>}
    {onDelete && <button type="button" onClick={() => { onClose(); onDelete(); }} className="sm:hidden shrink-0 p-1 rounded-full text-rose-500 hover:bg-rose-50" data-testid={`chat-bar-delete-${m.id}`}><Trash2 className="w-4 h-4" /></button>}
  </div>
);

export const ReactionChips = ({ m, me, names, mine, canReact, onChanged }) => {
  const list = Object.entries(m.reactions || {}).filter(([, v]) => v.length);
  if (!list.length) return null;
  return (
    <div className={`flex flex-wrap gap-1 mt-1 relative z-10 ${mine ? 'justify-end pr-2' : 'justify-start pl-10'}`} data-testid={`chat-reactions-${m.id}`}>
      {list.map(([e, ids]) => (
        <button key={e} type="button" disabled={!canReact} onClick={() => react(m.id, e, onChanged)} title={ids.map((u) => (u === me.id ? 'Eu' : names[u] || '?')).join(', ')}
          className={`flex items-center gap-0.5 text-[11px] rounded-full px-1.5 py-0.5 border shadow-sm transition-colors ${ids.includes(me.id) ? 'bg-sky-100 border-sky-300 text-sky-800' : 'bg-white border-slate-200 text-slate-600'}`}
          data-testid={`chat-reaction-chip-${m.id}-${REACTIONS.indexOf(e)}`}>
          <EmojiText text={e} size="1.1rem" />{ids.length > 1 && <span className="font-semibold">{ids.length}</span>}
        </button>
      ))}
    </div>
  );
};
